import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Statistics.css';

const Statistics = () => {
  const [stats, setStats] = useState({
    totalVisits: 0,
    monthlyVisits: 0,
    dailyVisits: 0,
    chartData: []
  });
  const [propertyStats, setPropertyStats] = useState({
    topProperties: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch visit statistics
      const visitsResponse = await axios.get('/api/stats/visits');
      setStats(visitsResponse.data);

      // Fetch property view statistics
      const propertyResponse = await axios.get('/api/stats/property-views');
      setPropertyStats(propertyResponse.data);

      setLoading(false);
    } catch (err) {
      console.error('Error fetching statistics:', err);
      setError(err.response?.data?.message || 'Error al cargar estadísticas');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="statistics-container">
        <h2>Estadísticas</h2>
        <div className="loading-message">Cargando estadísticas...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="statistics-container">
        <h2>Estadísticas</h2>
        <div className="error-message">{error}</div>
        <button onClick={fetchStatistics} className="retry-button">
          Reintentar
        </button>
      </div>
    );
  }

  return (
    <div className="statistics-container">
      <div className="statistics-header">
        <h2>Estadísticas del Sitio Web</h2>
        <button onClick={fetchStatistics} className="refresh-button">
          🔄 Actualizar
        </button>
      </div>

      <div className="stats-cards">
        <div className="stat-card total-visits">
          <div className="stat-icon">🌐</div>
          <div className="stat-content">
            <h3>Visitas Totales</h3>
            <p className="stat-number">{stats.totalVisits.toLocaleString()}</p>
            <span className="stat-label">Desde el inicio</span>
          </div>
        </div>

        <div className="stat-card monthly-visits">
          <div className="stat-icon">📅</div>
          <div className="stat-content">
            <h3>Visitas del Mes</h3>
            <p className="stat-number">{stats.monthlyVisits.toLocaleString()}</p>
            <span className="stat-label">Mes actual</span>
          </div>
        </div>

        <div className="stat-card daily-visits">
          <div className="stat-icon">📊</div>
          <div className="stat-content">
            <h3>Visitas de Hoy</h3>
            <p className="stat-number">{stats.dailyVisits.toLocaleString()}</p>
            <span className="stat-label">Últimas 24 horas</span>
          </div>
        </div>
      </div>

      {stats.chartData && stats.chartData.length > 0 && (
        <div className="chart-section">
          <h3>Últimos 30 Días</h3>
          <div className="simple-chart">
            {stats.chartData.map((day, index) => {
              const maxCount = Math.max(...stats.chartData.map(d => d.count), 1);
              const height = (day.count / maxCount) * 100;
              const dateObj = new Date(day.date);
              const dayNum = dateObj.getDate();
              const monthNum = dateObj.getMonth() + 1;
              
              return (
                <div key={index} className="chart-bar-container">
                  <div className="chart-bar-wrapper">
                    <div 
                      className="chart-bar" 
                      style={{ height: `${height}%` }}
                      title={`${day.date}: ${day.count} visitas`}
                    >
                      <span className="bar-value">{day.count}</span>
                    </div>
                  </div>
                  <span className="chart-label">
                    {dayNum}/{monthNum}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {propertyStats.topProperties && propertyStats.topProperties.length > 0 && (
        <div className="top-properties-section">
          <h3>Propiedades Más Vistas</h3>
          <div className="top-properties-list">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Propiedad</th>
                  <th>Ciudad</th>
                  <th>Vistas</th>
                </tr>
              </thead>
              <tbody>
                {propertyStats.topProperties.map((property, index) => (
                  <tr key={property.id}>
                    <td className="rank">{index + 1}</td>
                    <td className="property-title">{property.title}</td>
                    <td>{property.city}</td>
                    <td className="view-count">{property.viewCount.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Statistics;
